import type { ReactNode } from "react";

export type RevenueIntelligenceChartTooltipRow = {
  color?: string;
  label: string;
  value: ReactNode;
};

export function RevenueIntelligenceChartTooltip({
  label,
  rows,
}: {
  label?: ReactNode;
  rows: RevenueIntelligenceChartTooltipRow[];
}) {
  return (
    <div className="min-w-40 rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-xs shadow-lg">
      {label && (
        <p className="mb-2 font-medium leading-4 text-[#231942]">{label}</p>
      )}
      <div className="space-y-1.5">
        {rows.map((row, index) => (
          <div
            key={`${row.label}-${index}`}
            className="flex items-center justify-between gap-4"
          >
            <span className="inline-flex min-w-0 items-center gap-1.5 text-gray-500">
              {row.color && (
                <span
                  aria-hidden="true"
                  className="h-2 w-2 shrink-0 rounded-sm"
                  style={{ backgroundColor: row.color }}
                />
              )}
              <span className="truncate">{row.label}</span>
            </span>
            <span className="shrink-0 font-medium tabular-nums text-[#231942]">
              {row.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
